import { Eye, EyeOff } from 'lucide-react';

import { useAnnotationsStore } from '../../../context/zustand/annotationsStore';
import { useToggleAnnotationVisibility } from '../../../hooks/useToggleAnnotationVisibility';
import ToolButton from '../shared/ToolButton';

type AnnotationToolButtonVisibilityProps = {
  disabled?: boolean;
};

const AnnotationToolButtonVisibility: React.FC<
  AnnotationToolButtonVisibilityProps
> = ({ disabled }) => {
  // State store
  const annotations = useAnnotationsStore((state) => state.annotations);
  const areAllAnnotationsHidden = useAnnotationsStore(
    (state) => state.areAllAnnotationsHidden
  );

  const toggleAnnotationVisibility = useToggleAnnotationVisibility();

  return (
    <ToolButton
      tooltip="annotations.toggle_visibility"
      onClick={toggleAnnotationVisibility}
      disabled={disabled || annotations.length === 0}
    >
      {areAllAnnotationsHidden ? <Eye size={16} /> : <EyeOff size={16} />}
    </ToolButton>
  );
};

export default AnnotationToolButtonVisibility;
